export type WithdrawType = 'individual' | 'business';

export interface WithdrawFormData {
    withdrawType: WithdrawType;
    withdrawalMethod: string;
    firstName: string;
    lastName: string;
    ibanAccountNumber: string;
    swiftBic: string;
    recipientCountry: string;
    townCity: string;
    postcode: string;
    recipientAddress: string;
    cardNumber: string;
    nameOnCard: string;
    businessIbanAccountNumber: string;
    businessSwiftBic: string;
    businessName: string;
    businessCountry: string;
    businessTownCity: string;
    businessPostcode: string;
    businessAddress: string;
    amount: string;
    currency: string;
}

export const WITHDRAWAL_METHODS = [
    { label: 'To Card', value: 'card' },
    { label: 'To Bank Account', value: 'bank' },
];

export const CURRENCIES = [
    { label: 'USD', value: 'USD' },
    { label: 'EUR', value: 'EUR' },
    { label: 'GBP', value: 'GBP' },
    { label: 'JPY', value: 'JPY' },
];

export const COUNTRIES = [
    { label: 'United States', value: 'US' },
    { label: 'United Kingdom', value: 'UK' },
    { label: 'Germany', value: 'DE' },
    { label: 'France', value: 'FR' },
    { label: 'Spain', value: 'ES' },
    { label: 'Italy', value: 'IT' },
    { label: 'Canada', value: 'CA' },
    { label: 'Australia', value: 'AU' },
    { label: 'Japan', value: 'JP' },
    { label: 'China', value: 'CN' },
];
